import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1b8c76a5")

_pushScopeId("data-v-1b8c76a5")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "close", -1)
const _hoisted_2 = { id: "dlgBody" }
const _hoisted_3 = {
  key: 0,
  id: "dlgFooter"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    id: "wrapper",
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.close())),
    class: {clickable: !_ctx.modal}
  }, [
    _createVNode("div", {
      id: "dlgBox",
      style: 'max-width: '+_ctx.max_width+((_ctx.max_height!=null)? '; max-height: '+_ctx.max_height: ''),
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createVNode("h5", {
        id: "dlgHeader",
        class: {btnSpacing: !_ctx.modal}
      }, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.header_text) + " ", 1),
          (!_ctx.modal)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close())),
                id: "closeBtn"
              }, [
                _hoisted_1
              ]))
            : _createCommentVNode("", true)
        ], {}, true)
      ], 2),
      _createVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      (_ctx.hasFooter)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "footer", {}, undefined, true),
            (_ctx.buttons.length>0)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  id: "dlgButtons",
                  style: _ctx.buttons_style!=null? _ctx.buttons_style: ''
                }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buttons, (name, index) => {
                    return (_openBlock(), _createBlock("button", {
                      key: name,
                      onClick: ($event: any) => (_ctx.clicked(index))
                    }, _toDisplayString(name), 9, ["onClick"]))
                  }), 128))
                ], 4))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ], 2))
})